import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { error, errorHtml } from '../swal.model';
import Swal from 'sweetalert2';
import { AuthService } from '../../core/services/default/auth.service';

@Injectable({
  providedIn: 'root'
})

export class AuthLogoutGuard  {
  ls = localStorage;

  constructor(private router: Router, private auth: AuthService) {}

  canActivate(): boolean {
    return this.checkAuth();
  }

  checkAuth(): boolean {
    const tk = localStorage.getItem('user');

    if (tk) {
      const token = JSON.parse(tk);
      const dateNow = (new Date()).getTime() / 1000;
      const tkDate = new Date(token.expiresIn).getTime() / 1000;

      if (dateNow < tkDate) {
        return true;
      } else {
        this.auth.setMessageStatus(true);
        return false;
      }
    } else {
      return this.redirectToLogin();
    }
  }

  redirectToLogin() {
    // Navigate to the login
    this.router.navigate(['/login']).then(r => {});
    return false;
  }
}
